import React, { FC, useState, useEffect } from 'react';
import { Container, Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { searchProduct }  from '../../flux/actions/product-actions';
import Pagination from '@material-ui/lab/Pagination';

import { NotFoundSearch } from '../../views/NotFoundSearch';
import { ProductCard } from '../../components/ProductCard';
import ScreenLoader from '../../components/ScreenLoader';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { useStyles } from './styles';

const SearchResults: FC = () => {
    const classes = useStyles();
    const params = useParams();
    const dispatch = useDispatch();
    const keyword = (params as any).keyword;
    const [page, setPage] = useState(1);
    const searchProductList = useSelector((state: any) => state.productReducer);
    const { loading, searchProducts: { products = [] } , searchProducts: { totalPages = 1 } } = searchProductList;

    const handlePagination = (event: any, value: number) => {
        event.preventDefault();
        setPage(value);
    }

    useEffect(() => {
        dispatch(searchProduct(keyword, page));
    }, [keyword, page, dispatch])

    return (
        <div>
            {
                loading ? <ScreenLoader isOpen={loading}/> : 
                    products.length === 0 ? <NotFoundSearch/> :
                    <Container style={{marginBottom: '25px'}}>
                        <div style={{flex: '1', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                            <Link to="/">
                                <ArrowBackIcon className={classes.arrowBack}/>
                            </Link>
                            <h1 className={classes.title}>Mostrando resultados con "{keyword}"</h1>
                            <div></div>
                        </div>
                        <Grid
                            alignItems="center"
                            direction="row"
                            justify="center"
                            spacing={3}
                            container
                        >
                            {
                                products.map((product: any, id: number) => (
                                    <Grid item sm={4} key={id}>
                                        <ProductCard {...product} hideDescription/>
                                    </Grid>
                                ))
                            }
                        </Grid>
                        { totalPages > 1 && <Pagination count={totalPages} page={page} onChange={handlePagination} color="secondary" className={classes.pagination} /> }
                    </Container>
            }
        </div>
    );
}

export default SearchResults;
